import { render, staticRenderFns } from "./ServiceSelector.vue?vue&type=template&id=25816d98&scoped=true"
import script from "./ServiceSelector.vue?vue&type=script&lang=js"
export * from "./ServiceSelector.vue?vue&type=script&lang=js"
import style0 from "./ServiceSelector.vue?vue&type=style&index=0&id=25816d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25816d98",
  null
  
)

export default component.exports